import { BaseQueryFn } from "@reduxjs/toolkit/query"
import axios, { AxiosError, AxiosRequestConfig } from "axios"
import { isString } from "lodash"
import CheckBeforeRequest from "../../../Common/CheckBeforeRequest"

type Options = {
    baseUrl: string | ((
        queryParameters: {
            url: string
            method?: AxiosRequestConfig['method']
            data?: AxiosRequestConfig['data']
            params?: AxiosRequestConfig['params']
            headers?: AxiosRequestConfig['headers'],
            responseType?: AxiosRequestConfig['responseType'],
            noCms?: boolean,
            v2?: boolean
        }
    ) => string)
}

export const axiosBaseQuery = (options: Options): BaseQueryFn<
    {
        url: string
        method?: AxiosRequestConfig['method']
        data?: AxiosRequestConfig['data']
        params?: AxiosRequestConfig['params']
        headers?: AxiosRequestConfig['headers'],
        responseType?: AxiosRequestConfig['responseType']
    }
> => {
    return async (queryParameters) => {
        try {
            const { headers: preparedHeaders } = CheckBeforeRequest();
            const result = await axios({
                url: (isString(options.baseUrl) ? options.baseUrl : options.baseUrl(queryParameters)) + queryParameters.url,
                method: queryParameters.method,
                data: queryParameters.data,
                params: queryParameters.params,
                headers: {
                    ...preparedHeaders,
                    ...queryParameters.headers
                },
                responseType: queryParameters.responseType
            })
            return { data: result.data }
        } catch (axiosError) {
            const err = axiosError as AxiosError
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            }
        }
    };
}